// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolType, SelectionModeEnum } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
import { DynProperty } from '../../DynProperty';
export class HorizontalLineDataCacheTool extends DataCacheTool {
    /**
     * Constructor for HorizontalLineDataCacheTool
     */
    constructor() {
        super();
        this.LeftRay = false;
        this.ToolType = DataCacheToolType.HorizontalLine;
        this.InitPoints(1);
    }
    /**
     * Initializes the block for HorizontalLineDataCacheTool
     */
    InitBlock() {
        super.InitBlock();
        this.SelectionMode = SelectionModeEnum.Y;
    }
    /**
     * Gets the minimum points count required for the tool
     * @returns {number} - Minimum points count
     */
    MinPointsCount() {
        return 1;
    }
    /**
     * Gets the maximum points count required for the tool
     * @returns {number} - Maximum points count
     */
    MaxPointsCount() {
        return 1;
    }
    /**
     * Gets the properties of the tool
     * @returns {DynProperty[]} - Array of dynamic properties
     */
    Properties() {
        const properties = super.Properties();
        properties.push(new DynProperty('HorizontalLine.LeftRay', this.LeftRay, DynProperty.BOOLEAN, DynProperty.VISUAL_GROUP));
        return properties;
    }
    /**
     * Callback function for handling property changes
     * @param {DynProperty[]} properties - Array of dynamic properties
     */
    callBack(properties) {
        super.callBack(properties);
        const prop = DynProperty.getPropertyByName(properties, 'HorizontalLine.LeftRay');
        if (prop != null)
            this.LeftRay = prop.value;
    }
}
